import request from "@/api";

export function listNotice(data) {
    return request({
        url: '/api/notice/getNoticeList',
        method: 'get',
        params: data
    })
}
export function saveNotice(data) {
    return request({
        url: '/api/notice/saveNotice',
        method: 'post',
        data: data
    })
}
export function getNoticeInfo(data) {
    return request({
        url: '/api/notice/getNoticeInfo',
        method: 'get',
        params: data
    })
}

export function deleteNotice(data) {
    return request({
        url: '/api/notice/deleteNotice',
        method: 'post',
        data: data
    })
}
